import updateComparisonTimePeriodReducer from './reducers';

export default updateComparisonTimePeriodReducer;
